import { render } from "./tree.md?vue&type=template&id=e6607cc4"
import script from "./tree.md?vue&type=script&lang=js"
export * from "./tree.md?vue&type=script&lang=js"
script.render = render

export default script